<template>
  <a-modal :open="open" @cancel="closeForm" class="modal-no-padding">
    <div class="modal-no-padding__header">
      <h2>Эталонный профиль: {{ referenceProfile?.name ?? '' }}</h2>
    </div>
    <a-divider style="margin: 16px 0" />
    <div class="modal-no-padding__body">
      <div class="referece-report-data" v-if="!isPreloaded && referenceProfile">
        <div v-for="(value, key) in dictionary" :key="key" class="reference-block">
          <div>
            {{ value }}
          </div>
          <div class="reference-result">
            {{ referenceProfile[key] }}
          </div>
        </div>
      </div>
      <div v-else class="popup-preloader">
        <a-spin :size="'small'" />
      </div>
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <div class="action-buttons">
          <a-row justify="end" :gutter="8">
            <a-col>
              <a-button class="secondary-button" @click="closeForm">Закрыть</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {useStore} from "vuex";
import {computed, onBeforeMount, ref} from "@vue/runtime-core";
import Preloader from "@/components/Technical/Preloader.vue";
import CustomInput from "@/components/Forms/Fields/CustomInput.vue";

export default {
  components: {CustomInput, Preloader},
  props: {
    profileId: [String, Number],
    open: Boolean,
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const isPreloaded = ref(true);

    const dictionary = {
      total: "Общий ЭИ",
      domain_1: "Опытный домен",
      domain_2: "Стратегический домен",
      branch_1: "Распознавание эмоций",
      branch_2: "Использование эмоций",
      branch_3: "Анализ эмоций",
      branch_4: "Управление эмоциями",
      section_1: "Раздел 1 (Распознавание эмоций в лицах)",
      section_2: "Раздел 2 (Применение эмоций в действиях и мышлении)",
      section_3: "Раздел 3 (Понимание смены эмоций)",
      section_4: "Раздел 4 (Регуляция своих эмоций)",
      section_5: "Раздел 5 (Изображения)",
      section_6: "Раздел 6 (Эмпатия)",
      section_7: "Раздел 7 (Смешивания)",
      section_8: "Раздел 8 (Влияние на эмоции других)",
      section_9a: "Раздел 9а (Распознавание эмоций в контексте ситуаций)",
      section_9b: "Раздел 9б (Понимание изменения эмоций в контексте ситуаций)",
    };

    const referenceProfile = computed(
        () => store.state.analytics.referenceProfile
    );

    onBeforeMount(() => {
      isPreloaded.value = true;
      store.dispatch("analytics/getReferenceProfile", props.profileId).finally(() => {
        isPreloaded.value = false;
      });
    })

    const closeForm = () => {
      context.emit('close');
    }

    return {
      closeForm,
      isPreloaded,
      referenceProfile,
      dictionary
    }
  }
}
</script>

<style scoped lang="scss">
  .popup-preloader {
    display: flex;
    margin: auto;
    justify-content: center;
  }

  .referece-report-data {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .reference-block {
    display: flex;
    gap: 8px;
    justify-content: space-between;
  }

  .reference-result {
    font-size: 16px;
    font-weight: 500;
  }
</style>